import { User } from "../../model";
/**
 * Parses an User model and returns a formatted address string.
 *
 * @param {Object} addressObj - The address object to parse.
 * @param {string} addressObj.street_name - The name of the street.
 * @param {string} [addressObj.building_number] - The building number.
 * @param {string} [addressObj.apartment_number] - The apartment number.
 * @returns {string} - The formatted address string.
 */

export function parseAddress(user: User | undefined) {
    if(!user) return null;
    
    const { street_name, building_number, apartment_number } = user;

    if(!street_name) return null;

    let address = street_name;

    if (building_number) {
        address += ` ${building_number}`;

        if (apartment_number) {
            address += ` / ${apartment_number}`;
        }
    }

    return address;
}